import React from "react";

export default function Policies() {
  const updated = "September 1, 2025";

  return (
    <main className="py-10">
      <div className="container-x space-y-6">
        {/* Header */}
        <header className="text-center md:text-left">
          <p className="uppercase tracking-[0.2em] text-[#D4FF00] font-extrabold text-xs">
            Policies
          </p>
          <h1 className="text-3xl md:text-4xl font-extrabold mt-1">Studio Policies & Privacy</h1>
          <p className="text-neutral-400 text-sm mt-1">Last updated: {updated}</p>
        </header>

        {/* Privacy Policy */}
        <section id="privacy" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">Privacy Policy</h2>
          <p className="text-neutral-400">
            We collect only what we need to run bookings and provide support. This includes your
            name, email, and optional phone when you contact us or book a session.
          </p>

          <div className="grid md:grid-cols-2 gap-4 mt-4">
            <div className="bg-[#0a0a0a] rounded-xl border border-[#1a1a1a] p-4">
              <h3 className="font-semibold mb-1">What we collect</h3>
              <ul className="text-neutral-300 text-sm space-y-1">
                <li>• Contact details (name, email, phone)</li>
                <li>• Booking preferences (date/time, rig count)</li>
                <li>• Basic analytics (page views, device type)</li>
              </ul>
            </div>
            <div className="bg-[#0a0a0a] rounded-xl border border-[#1a1a1a] p-4">
              <h3 className="font-semibold mb-1">How we use it</h3>
              <ul className="text-neutral-300 text-sm space-y-1">
                <li>• Confirm bookings and send updates</li>
                <li>• Respond to support questions</li>
                <li>• Improve site performance and safety</li>
              </ul>
            </div>
          </div>

          <div className="mt-4 text-neutral-300 text-sm space-y-1">
            <p><span className="font-semibold">Data sharing:</span> We don’t sell your data. We share only with services needed to operate (e.g., email, analytics), bound by their privacy terms.</p>
            <p><span className="font-semibold">Data retention:</span> Booking/contact records are kept as required for operations, then deleted when no longer needed.</p>
            <p><span className="font-semibold">Your choices:</span> Email <a className="underline hover:text-[#D4FF00]" href="mailto:info@revytech.ca">info@revytech.ca</a> to request access, updates, or deletion of your info.</p>
          </div>
        </section>

        {/* House Rules */}
        <section id="house-rules" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">House Rules</h2>
          <ul className="text-neutral-300 space-y-2 text-sm">
            <li>• Respect players and staff. Harassment or cheating isn’t tolerated.</li>
            <li>• Use your own game accounts and follow game publishers’ terms.</li>
            <li>• Drinks in lidded cups only at desks; food in lounge areas.</li>
            <li>• Handle equipment with care; report any issues immediately.</li>
            <li>• We may relocate seats to optimize rig availability during busy periods.</li>
          </ul>
        </section>

        {/* Bookings / Cancellations */}
        <section id="cancellations" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">Bookings & Cancellations</h2>
          <div className="text-neutral-300 text-sm space-y-2">
            <p><span className="font-semibold">Changes:</span> Contact us ASAP to adjust time, rig count, or date. We’ll do our best to accommodate.</p>
            <p><span className="font-semibold">Cancellations:</span> Please give 12+ hours notice. Late cancellations and no-shows may be charged up to one hour per seat.</            p>
            <p><span className="font-semibold">Groups/parties:</span> A deposit may be required to hold multiple rigs or a private area.</p>
          </div>
        </section>

        {/* Age / Food & Drinks */}
        <section id="age-food" className="scroll-mt-[80px] card p-5">
          <h2 className="text-xl font-bold mb-2">Age Policy & Food/Drinks</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-[#0a0a0a] rounded-xl border border-[#1a1a1a] p-4">
              <h3 className="font-semibold mb-1">Age Policy</h3>
              <p className="text-neutral-400 text-sm">
                Under 12 must be accompanied by an adult/guardian in the venue. Parental
                permission may be required for certain titles.
              </p>
            </div>
            <div className="bg-[#0a0a0a] rounded-xl border border-[#1a1a1a] p-4">
              <h3 className="font-semibold mb-1">Food & Drinks</h3>
              <p className="text-neutral-400 text-sm">
                Café items only at desks to protect equipment. Outside food is welcome in the
                lounge/seating areas.
              </p>
            </div>
          </div>
        </section>

        <p className="text-xs text-neutral-500">
          This page is for general information and is not legal advice.
        </p>
      </div>
    </main>
  );
}
